module.exports = __webpack_public_path__ + "img/wild.6fa4dfa4.png";